import * as http from 'utils/http';
import config from 'config';

const unlockShipperOrder = (id, { unlock_reason, unlock_comment }) => {
  return http.patch(`${config.API_URL}gatekeeper/${id}/unlock/`, {
    unlock_reason,
    unlock_comment,
  });
};

const unlockJourney = (id, { unlock_reason, unlock_comment }) => {
  return http.patch(`${config.API_URL}assignment/journeys/${id}/unlock/`, {
    unlock_reason,
    unlock_comment,
  });
};

export { unlockShipperOrder, unlockJourney };
